import MyStoresStore from './MyStoresStore'

export default MyStoresStore
